import React from 'react';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import { Icon as ReactIcon } from '@a-ui/react';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import Typography from '../Typography';

export interface ModalProps
  extends IClassNames,
    Omit<
      ReactModalProps,
      | 'appElement'
      | 'overlayClassName'
      | 'bodyOpenClassName'
      | 'htmlOpenClassName'
      | 'className'
      | 'role'
    > {
  title?: ITranslations;
}

ReactModal.setAppElement('#root');
const Modal: React.FC<ModalProps> = ({ children, classNames, title, onRequestClose, ...props }) => {
  const { className } = useClassNames('m-modal', 'm-modal--large', classNames);

  return (
    <ReactModal
      overlayClassName="m-overlay is-active"
      className={className}
      bodyOpenClassName="u-modal-open"
      htmlOpenClassName="u-modal-open"
      role="dialog"
      aria-modal="true"
      onRequestClose={onRequestClose}
      aria-labelledby={title && 'modal-title'}
      aria-describedby="modal-content"
      {...props}
    >
      <div className="m-modal__content">
        <div className="m-modal__header u-margin-bottom-xs">
          <button
            className="m-modal__close a-button-transparent a-button--default has-icon u-margin-xs"
            aria-label={translate('common.button.close')}
            onClick={onRequestClose}
          >
            <ReactIcon name="ai-close" />
          </button>

          {title && (
            <Typography id="modal-title" variant="h4" as="h6">
              {translate(title)}
            </Typography>
          )}
        </div>

        <div id="modal-content">{children}</div>
      </div>
    </ReactModal>
  );
};

export default Modal;
